"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteActivityData = exports.updateActivitiesData = exports.insertActivityData = exports.fetchActivitiesData = void 0;
var serviceUtils_1 = require("../../youwell-common/service/serviceUtils");
var apiUrls_1 = __importDefault(require("../../youwell-common/apiUrls"));
var ActivityDataStore_1 = require("../store/ActivityDataStore");
var fetchActivitiesData = function (dispatch, queryParams, options) {
    (0, serviceUtils_1.fetchFromYouwellApi)(dispatch, {
        apiPath: apiUrls_1.default.app.activity,
        dataAction: ActivityDataStore_1.getActivities,
        queryParams: queryParams,
    }, options);
};
exports.fetchActivitiesData = fetchActivitiesData;
var insertActivityData = function (dispatch, activityData, options) {
    (0, serviceUtils_1.fetchFromYouwellApi)(dispatch, {
        apiPath: apiUrls_1.default.app.activity,
        dataAction: ActivityDataStore_1.insertActivity,
        method: 'POST',
        body: activityData,
    }, options);
};
exports.insertActivityData = insertActivityData;
var updateActivitiesData = function (dispatch, activityData, options) {
    (0, serviceUtils_1.fetchFromYouwellApi)(dispatch, {
        apiPath: apiUrls_1.default.app.activity,
        dataAction: ActivityDataStore_1.updateActivities,
        method: 'PUT',
        body: activityData,
    }, options);
};
exports.updateActivitiesData = updateActivitiesData;
var deleteActivityData = function (dispatch, activityData, options) {
    (0, serviceUtils_1.fetchFromYouwellApi)(dispatch, {
        apiPath: "".concat(apiUrls_1.default.app.activity, "/").concat(activityData.id),
        dataAction: ActivityDataStore_1.deleteActivity,
        method: 'DELETE',
        body: activityData,
    }, options);
};
exports.deleteActivityData = deleteActivityData;
